"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const PageHelper_1 = require("@react/web/SubscriptionOfferDetail/PageHelper/PageHelper");
class PriceOffer {
    constructor(assignedInquiryType, priceOfferId, mileageYearly, amount, startingFeeAmount, priceOfferDetailUrl, contractLengths) {
        this.assignedInquiryType = assignedInquiryType;
        this.priceOfferId = priceOfferId;
        this.mileageYearly = mileageYearly;
        this.amount = amount;
        this.startingFeeAmount = startingFeeAmount;
        this.priceOfferDetailUrl = priceOfferDetailUrl;
        this.contractLengths = contractLengths;
    }
    isFlexible() {
        return this.assignedInquiryType === PageHelper_1.InquiryOfferTypesEnum.FLEXIBLE;
    }
    isFixterm() {
        return this.assignedInquiryType === PageHelper_1.InquiryOfferTypesEnum.FIXTERM;
    }
    isMinterm() {
        return this.assignedInquiryType === PageHelper_1.InquiryOfferTypesEnum.MINTERM;
    }
}
exports.default = PriceOffer;
